import React from 'react';
import { ArticleCard, ArticleCardMedia, ArticleCardVariant } from '@lux/article-card';
import { ImageSize, useConfig } from '@browsing/config';
import { getArticleCardUrl } from './helpers';
export var BaseArticleCard = function (_a) {
    var campaignIdentifier = _a.campaignIdentifier, catalogType = _a.catalogType, children = _a.children, handleOnClick = _a.handleOnClick, media = _a.media, navigationSource = _a.navigationSource, sku = _a.sku, _b = _a.variant, variant = _b === void 0 ? ArticleCardVariant.COMPACT_INLINE : _b, recommendedBy = _a.recommendedBy, themeHash = _a.themeHash;
    var config = useConfig();
    var imageMedia = media.find(function (item) { return !item.media_type || item.media_type === 'IMAGE'; });
    var image = (imageMedia === null || imageMedia === void 0 ? void 0 : imageMedia.path) ? config.getImage(imageMedia.path, ImageSize.Small) : '';
    var altText = (imageMedia === null || imageMedia === void 0 ? void 0 : imageMedia.alt_text) || '';
    var catalogUrl = getArticleCardUrl({
        campaignIdentifier: campaignIdentifier,
        catalog: catalogType,
        sku: sku,
        source: navigationSource,
        recommendedBy: recommendedBy,
        themeHash: themeHash,
    });
    return (React.createElement(ArticleCard, { onClick: handleOnClick, path: catalogUrl, variant: variant },
        children,
        React.createElement(ArticleCardMedia, { primaryImage: { src: image, alt: altText } })));
};
